module.exports = __webpack_public_path__ + "img/1.3-en.4dad598f.png";